export const SETTINGS_ICON = '/assets/images/icons/settings.svg';
export const LOGO_BLACK_SMALL_SIMPLE = '../../assets/images/logos/jammcard-simple.svg';
